// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__OzpUA","overflowing":"ReadFullNote_overflowing__2SnQW"};